module.exports = __webpack_public_path__ + "img/check.a0ec4fc6.svg";